<template>
  <div class="modal fade" id="pricingModal" tabindex="-1" aria-labelledby="pricingModalLabel" aria-hidden="true"
    ref="pricingModal">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header px-md-5 d-flex justify-content-between align-items-center">
          <h5 class="modal-title font-3 label-1" id="pricingModalLabel">Planes y Precios</h5>
          <button type="button" class="btn-close-custom" data-bs-dismiss="modal" aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="modal-body px-md-5 py-4">
          <p class="pricing-description text-center fuente-nova">
            {{ description }}
          </p>
          <p class="pricing-amount text-center fuente-posm">
            Desde <span class="price-highlight">{{ price }}</span>/mes
          </p>
          <div class="text-center mt-4">
            <button class="btn-contact fuente-nova2" @click="openContact">
              Contáctanos
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from 'bootstrap'
import { openContactModal } from '@/utils/modalHelper'

const { Modal } = bootstrap

export default {
  name: 'PricingModal',
  data() {
    return {
      modalInstance: null,
      description: 'Todo lo que necesitas para transformar la experiencia de tus clientes, en un solo lugar.',
      price: '$600 MXN'
    }
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.pricingModal)
    window.addEventListener('pricing-modal-open', this.handlePricingData)
  },
  beforeUnmount() {
    this.modalInstance?.hide()
    window.removeEventListener('pricing-modal-open', this.handlePricingData)
  },
  methods: {
    showModal() {
      this.modalInstance.show()
    },
    openContact() {
      const pricingModal = document.getElementById('pricingModal')
      const bsModal = bootstrap.Modal.getInstance(pricingModal)
      if (bsModal) {
        bsModal.hide()
      }
      pricingModal.addEventListener('hidden.bs.modal', () => {
        openContactModal()
      }, { once: true })
    },
    handlePricingData(event) {
      if (event.detail) {
        this.description = event.detail.description
        this.price = event.detail.price
      }
    }
  }
}
</script>

<style scoped>
.modal-content {
  border-radius: 30px !important;
}

.btn-close-custom {
  border: none;
  background: transparent;
  color: #999;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
}

.btn-close-custom:hover {
  color: #333;
}

.label-1 {
  font-size: 28px;
  font-weight: 600;
  color: var(--color-2);
}

@media (min-width: 0px) and (max-width: 768px) {
  .modal-content {
    border-radius: 15px !important;
  }
}

.pricing-description {
  font-size: 18px;
  color: #555;
  margin-bottom: 30px;
  line-height: 1.5;
}

.pricing-amount {
  font-size: 24px;
  color: var(--color-2);
  margin: 0;
}

.price-highlight {
  font-weight: 700;
  font-size: 32px;
}

.btn-contact {
  background-color: var(--color-2);
  color: white;
  border: none;
  border-radius: 30px;
  padding: 12px 40px;
  font-size: 16px;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.btn-contact:hover {
  opacity: 0.85;
}
</style>
